var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-el-select',{attrs:{"options":_vm.options},on:{"input":_vm.handleInput},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }